import { Button, Card, DisplayText, Icon, Stack, Toast } from "@shopify/polaris"
import { ChevronLeftMinor, ChevronRightMinor, SettingsMajor } from "@shopify/polaris-icons"
import React, { Component } from "react"
import { connect } from "react-redux"
import Sidebar from "react-sidebar"
import { bindActionCreators } from "redux"
import Actions from "../../actions"
import Preloader from "../../components/Preloader"
import TemplateCustom from "../../components/WishlistApp/TemplateCustom"
import "./styles.scss"
const INITIAL_STATE = {
    isReady: false,
    isLoading: false,
    openSidebar: false,
    openTemplateCustom: false,
    toast: {
        show: false,
        content: "",
        error: false,
    },
    wishlist_settings_edited: [],
    compare_settings_edited: [],
    general_settings_edited: [],
    errorValidate: {
        error_1: "", // wishlist add class error
        error_2: "", // wishlist show class error
        error_2a: "", // wishlist remove class error
        error_3: "", // compare add class error
        error_4: "", // compare show class error
        error_4a: "", // compare remove class error
    },
}

function mapStateToProps(state) {
    return {
        widgets: state.widgets,
        widget_selected: state.widget_selected,
        app_edited: state.app_edited,
        app_render: state.app_render,
        plan: state.plan,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

class WishlistPage extends Component {
    constructor(props) {
        super(props)
        this.state = Object.assign({}, INITIAL_STATE)
        // this.child = React.createRef();
    }

    static getDerivedStateFromProps(props, state) {
        const { widget_selected } = props
        if (JSON.stringify(widget_selected) !== "{}") {
            return { isReady: true }
        }

        return null
    }

    componentDidMount() {}

    renderLeftContent = () => {
        const { redirectToPage } = this.props
        return <TemplateCustom goBack={async () => redirectToPage("WidgetsManagement")} />
    }

    renderPreviewHeader() {
        const { widget_selected } = this.props
        const { wishlist_settings } = this.props.app_render
        const { launch_show } = wishlist_settings
        return (
            <div style={{ padding: "20px" }}>
                <Stack alignment="center">
                    <Stack.Item>
                        <svg
                            width="1.125em"
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="home"
                            className="svg-inline--fa fa-home fa-w-18 fa-2x "
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 576 512"
                            style={{ color: "rgb(224, 241, 255)" }}
                        >
                            <path
                                fill="currentColor"
                                d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
                            />
                        </svg>
                    </Stack.Item>
                    <Stack.Item fill></Stack.Item>
                    <Stack.Item>
                        <div
                            style={{
                                width: "200px",
                                height: "18px",
                                backgroundColor: "rgb(224, 241, 255)",
                            }}
                        />
                    </Stack.Item>
                    {widget_selected.id == 0 && launch_show.type == "header" ? (
                        <Stack.Item>
                            <svg
                                width={wishlist_settings.show_class_icon.width}
                                height={wishlist_settings.show_class_icon.height}
                                aria-hidden="true"
                                focusable="false"
                                fill={wishlist_settings.show_class_icon.icon_color}
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox={wishlist_settings.show_class_icon.view_box}
                                dangerouslySetInnerHTML={{
                                    __html: wishlist_settings.show_class_icon.svg,
                                }}
                            ></svg>
                        </Stack.Item>
                    ) : (
                        ""
                    )}
                </Stack>
            </div>
        )
    }

    renderPreviewMenu() {
        const { widget_selected } = this.props
        const { wishlist_settings } = this.props.app_render
        const { launch_show } = wishlist_settings
        let item = []
        let i = 0
        for (i; i < 3; i++) {
            item.push(
                <Stack.Item key={i}>
                    <div
                        style={{
                            width: "50px",
                            height: "12px",
                            backgroundColor: "rgb(224, 241, 255)",
                        }}
                    />
                </Stack.Item>,
            )
        }
        if (widget_selected.id == 0 && launch_show.type == "menu") {
            item.push(
                <Stack.Item key={i + 1}>
                    <div>WISHLIST</div>
                </Stack.Item>,
            )
        }
        return (
            <div className="center-flex">
                <Stack alignment="center">{item}</Stack>
            </div>
        )
    }

    renderPreviewContentProductPage() {
        const { widget_selected } = this.props
        const { wishlist_settings } = this.props.app_render
        const { launch_add_product_page } = wishlist_settings
        let item = []
        for (let i = 0; i < 4; i++) {
            item.push(
                <Stack.Item key={i}>
                    <div className="line" />
                </Stack.Item>,
            )
        }
        return (
            <Stack>
                <Stack.Item>
                    <div className="center-flex content-img">
                        <svg
                            height="84px"
                            width="84px"
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="image"
                            className="svg-inline--fa fa-image fa-w-16 fa-6x "
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            style={{ color: "rgb(224, 241, 255)" }}
                        >
                            <path
                                fill="currentColor"
                                d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
                            />
                        </svg>
                    </div>
                </Stack.Item>
                <Stack.Item fill>
                    <div className="center-flex">
                        <Stack vertical>
                            {widget_selected.id == 2 ? (
                                <div className="add-wl-parent" style={{
                                    margin: wishlist_settings.add_selector.margin !== 'undefined' ? wishlist_settings.add_selector.margin : '',
                                    padding: wishlist_settings.add_selector.padding !== 'undefined' ? wishlist_settings.add_selector.padding: '',
                            }}>
                                    <div
                                        className="add-wl"
                                        style={
                                            launch_add_product_page.showBackground
                                                ? launch_add_product_page.showTittle
                                                    ? {
                                                          backgroundColor:
                                                              launch_add_product_page.background_color,
                                                          width:
                                                              launch_add_product_page.width + "px",
                                                          height:
                                                              launch_add_product_page.height + "px",
                                                          borderRadius:
                                                              launch_add_product_page.borderRadius +
                                                              "px",
                                                      }
                                                    : {
                                                          backgroundColor:
                                                              launch_add_product_page.background_color,
                                                          width:
                                                              launch_add_product_page.width + "px",
                                                          height:
                                                              launch_add_product_page.height + "px",
                                                          borderRadius:
                                                              launch_add_product_page.borderRadius +
                                                              "px",
                                                      }
                                                : {}
                                        }
                                    >
                                        <svg
                                            width={wishlist_settings.add_class_icon_product.width}
                                            height={wishlist_settings.add_class_icon_product.height}
                                            aria-hidden="true"
                                            focusable="false"
                                            fill={
                                                wishlist_settings.add_class_icon_product.icon_color
                                            }
                                            role="img"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox={
                                                wishlist_settings.add_class_icon_product.view_box
                                            }
                                            dangerouslySetInnerHTML={{
                                                __html: wishlist_settings.add_class_icon_product
                                                    .svg,
                                            }}
                                        ></svg>
                                    </div>
                                    <div
                                        className={"title-wl"}
                                        style={{
                                            color: launch_add_product_page.text_color,
                                            marginLeft: "10px",
                                        }}
                                    >
                                        {launch_add_product_page.showTittle && (
                                            <span>{launch_add_product_page.text}</span>
                                        )}
                                    </div>
                                    {(launch_add_product_page.showCount ||
                                    this.props.plan.plan == "free"
                                        ? true
                                        : false) && <div className="count">5</div>}
                                </div>
                            ) : (
                                ""
                            )}
                            {item}
                        </Stack>
                    </div>
                </Stack.Item>
            </Stack>
        )
    }

    renderPreviewContent() {
        const { widget_selected } = this.props
        const { wishlist_settings } = this.props.app_render
        const { launch_add } = wishlist_settings
        let item = []
        for (let i = 0; i < 4; i++) {
            item.push(
                <Stack.Item key={i}>
                    <div className="line" />
                </Stack.Item>,
            )
        }
        return (
            <Stack>
                <Stack.Item>
                    <div className="center-flex content-img">
                        <svg
                            height="84px"
                            width="84px"
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="image"
                            className="svg-inline--fa fa-image fa-w-16 fa-6x "
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            style={{ color: "rgb(224, 241, 255)" }}
                        >
                            <path
                                fill="currentColor"
                                d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
                            />
                        </svg>
                    </div>
                </Stack.Item>
                <Stack.Item fill>
                    <div className="center-flex">
                        <Stack vertical>
                            {widget_selected.id == 1 ? (
                                <div className="add-wl-parent">
                                    <div
                                        className="add-wl"
                                        style={
                                            launch_add.showBackground
                                                ? launch_add.showTittle
                                                    ? {
                                                          backgroundColor:
                                                              launch_add.background_color,
                                                          width: launch_add.width + "px",
                                                          height: launch_add.height + "px",
                                                          borderRadius:
                                                              launch_add.borderRadius + "px",
                                                      }
                                                    : {
                                                          backgroundColor:
                                                              launch_add.background_color,
                                                          width: launch_add.width + "px",
                                                          height: launch_add.height + "px",
                                                          borderRadius:
                                                              launch_add.borderRadius + "px",
                                                      }
                                                : {}
                                        }
                                    >
                                        <svg
                                            width={wishlist_settings.add_class_icon.width}
                                            height={wishlist_settings.add_class_icon.height}
                                            aria-hidden="true"
                                            focusable="false"
                                            fill={wishlist_settings.add_class_icon.icon_color}
                                            role="img"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox={wishlist_settings.add_class_icon.view_box}
                                            dangerouslySetInnerHTML={{
                                                __html: wishlist_settings.add_class_icon.svg,
                                            }}
                                        ></svg>
                                    </div>
                                    <div
                                        className={"title-wl"}
                                        style={{ color: launch_add.text_color, marginLeft: "10px" }}
                                    >
                                        {launch_add.showTittle && <span>{launch_add.text}</span>}
                                    </div>
                                    {(launch_add.showCount || this.props.plan.plan == "free"
                                        ? true
                                        : false) && <div className="count">5</div>}
                                </div>
                            ) : (
                                ""
                            )}
                            {item}
                        </Stack>
                    </div>
                </Stack.Item>
            </Stack>
        )
    }

    renderPreviewFooter() {
        let item = []
        for (let i = 0; i < 3; i++) {
            item.push(
                <Stack.Item key={i}>
                    <div
                        className="center-flex"
                        style={{
                            height: "90px",
                            width: "140px",
                            border: "2px solid rgb(224, 241, 255)",
                        }}
                    >
                        <svg
                            height="42px"
                            width="42px"
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="image"
                            className="svg-inline--fa fa-image fa-w-16 fa-3x "
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            style={{ color: "rgb(224, 241, 255)" }}
                        >
                            <path
                                fill="currentColor"
                                d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
                            />
                        </svg>
                    </div>
                </Stack.Item>,
            )
        }
        return (
            <Stack vertical>
                <Stack.Item>
                    <div
                        style={{
                            width: "460px",
                            height: "4px",
                            backgroundColor: "rgb(224, 241, 255)",
                        }}
                    />
                </Stack.Item>
                <Stack.Item>
                    <div
                        style={{
                            width: "460px",
                            height: "4px",
                            backgroundColor: "rgb(224, 241, 255)",
                        }}
                    />
                </Stack.Item>
                <Stack.Item>
                    <Stack distribution="fillEvenly">{item}</Stack>
                </Stack.Item>
            </Stack>
        )
    }

    render() {
        const { redirectToPage, actions, widget_selected } = this.props
        const { wishlist_settings } = this.props.app_render
        const { openSidebar, toast, isReady, isLoading } = this.state
        const { launch_show } = wishlist_settings
        const { position_button } = launch_show
        let title = ""
        switch (widget_selected.id) {
            case 0:
                title = "Show wishlist button setting"
                break
            case 1:
                title = "Add to Wishlist Button setting"
                break
            case 2:
                title = "Add to Wishlist Button on Product page setting"
                break
            case 3:
                title = "Remove wishlist button setting"
                break
            default:
                title = "Show wishlist button setting"
        }

        return isReady ? (
            <div className="widget-create">
                {isLoading && <Preloader />}

                <Card.Section>
                    <div className="page-breadcrumbs">
                        <Button
                            plain
                            icon={ChevronLeftMinor}
                            size="slim"
                            onClick={async () => redirectToPage("WidgetsManagement")}
                        >
                            Back to list
                        </Button>
                    </div>

                    <div className="page-title">{title}</div>
                </Card.Section>
                <Card.Section>
                    {/* <div className="section-title">
                        <DisplayText size="small">Adjust settings</DisplayText>
                    </div> */}

                    {/* Mobile section */}
                    <div
                        className="mobile-section-title"
                        onClick={() => this.setState({ openSidebar: !openSidebar })}
                    >
                        <div className="title">
                            <div className="btn-icon">
                                {openSidebar ? (
                                    <Icon source={ChevronLeftMinor} color="white" />
                                ) : (
                                    <Icon source={SettingsMajor} color="white" />
                                )}
                            </div>
                            <div className="subtitle">
                                {openSidebar ? "Back to preview" : "Wiget Settings"}
                            </div>
                        </div>
                        <div className="btn-icon">
                            {!openSidebar && <Icon source={ChevronRightMinor} color="white" />}
                        </div>
                    </div>

                    {/* Desktop section */}
                    <div className="widget-create-body" id="yta-widget-create-body">
                        <div className="left-content">{this.renderLeftContent()}</div>
                        <div className="right-content">
                            <div className="preview-block">
                                <div className="centered-content preview-component">
                                    <div className="page-review">
                                        <Card>
                                            {this.renderPreviewHeader()}
                                            <hr
                                                style={{ border: "1px solid rgb(224, 241, 255)" }}
                                            />
                                            {widget_selected.id == 0 &&
                                            launch_show.type == "floating" ? (
                                                <div
                                                    className="floating"
                                                    style={{
                                                        backgroundColor:
                                                            position_button.background_color,
                                                        minWidth: position_button.minWidth,
                                                        minHeight: position_button.minHeight,
                                                        height: position_button.height + "px",
                                                        width: position_button.width + "px",
                                                        bottom: position_button.bottom,
                                                        right: position_button.right,
                                                        left: position_button.left,
                                                        top: position_button.top,
                                                        color: position_button.text_color,
                                                        position: position_button.position,
                                                        boxShadow: position_button.boxShadow,
                                                        borderRadius:
                                                            position_button.borderRadius + "px",
                                                    }}
                                                >
                                                    <div className="show-wl">
                                                        <div className="title-wl">
                                                            <svg
                                                                width={
                                                                    wishlist_settings
                                                                        .show_class_icon.width
                                                                }
                                                                height={
                                                                    wishlist_settings
                                                                        .show_class_icon.height
                                                                }
                                                                aria-hidden="true"
                                                                focusable="false"
                                                                fill={
                                                                    wishlist_settings
                                                                        .show_class_icon.icon_color
                                                                }
                                                                role="img"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox={
                                                                    wishlist_settings
                                                                        .show_class_icon.view_box
                                                                }
                                                                dangerouslySetInnerHTML={{
                                                                    __html: wishlist_settings
                                                                        .show_class_icon.svg,
                                                                }}
                                                            ></svg>
                                                            {launch_show.showTittle && (
                                                                <span>{launch_show.text}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                            {this.renderPreviewMenu()}
                                            <hr
                                                style={{ border: "1px solid rgb(224, 241, 255)" }}
                                            />
                                            <div className="pg-content">
                                                {widget_selected.id != 2 &&
                                                    this.renderPreviewContent()}
                                                {widget_selected.id == 2 &&
                                                    this.renderPreviewContentProductPage()}
                                                <br />
                                                {this.renderPreviewFooter()}
                                            </div>
                                        </Card>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`sidebar sidebar-${openSidebar ? "open" : "hidden"}`}>
                            <Sidebar
                                sidebar={this.renderLeftContent()}
                                open={openSidebar}
                                onSetOpen={() => this.setState({ openSidebar: !openSidebar })}
                            >
                                <div></div>
                            </Sidebar>
                        </div>
                    </div>
                </Card.Section>
                {toast.show && (
                    <Toast
                        content={toast.content}
                        error={toast.error}
                        onDismiss={() =>
                            this.setState({
                                toast: { show: false, content: "", error: false },
                            })
                        }
                    />
                )}
            </div>
        ) : (
            <Preloader />
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WishlistPage)
